import * as React from "react";

import { Loader } from "@/components/ui/loader";

// Dynamic import boundary: the editor engine, fonts and their wasm stay in their own chunk.
const DocxEditorAdapter = React.lazy(() => import("./DocxEditorAdapter"));

type Props = React.ComponentProps<typeof DocxEditorAdapter>;

export const LazyDocxEditor: React.FC<Props> = props => (
  <React.Suspense
    fallback={
      <div className="flex h-full items-center justify-center" aria-label="Loading editor">
        <Loader className="h-8 w-8 text-coral" />
      </div>
    }
  >
    <DocxEditorAdapter {...props} />
  </React.Suspense>
);
